import { render, staticRenderFns } from "./Reciepts.vue?vue&type=template&id=34b91892"
import script from "./Reciepts.vue?vue&type=script&lang=js"
export * from "./Reciepts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports